// extracted by mini-css-extract-plugin
export var createdDate = "_jn-1";
export var divider = "_jn-2";
export var headerDivider = "_jn-3";
export var messagesCard = "_jn-0";
export var messagesContainer = "_jn-7";
export var messagesContainerWrapper = "_jn-4";
export var pointerCapturingButtonBoxes = "_jn-a";
export var showLeftPanelButton = "_jn-9";
export var showMoreButton = "_jn-c";
export var showMoreButtonContainer = "_jn-b";
export var summaryTitle = "_jn-6";
export var systemMessageCardWrapper = "_jn-d";
export var topButtons = "_jn-8";
export var withPadding = "_jn-5";